import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">⚠️ JUMPVENDOR ALERT</div>
            <p className="footer__desc">
              Site indépendant d'information et d'alerte contre la fraude en ligne.
              Nous ne sommes affiliés à aucune entité commerciale.
            </p>
          </div>

          <div className="footer__links">
            <h4>Liens rapides</h4>
            <ul>
              <li><a href="#comment-ca-marche">Comment ça marche</a></li>
              <li><a href="#temoignages">Témoignages</a></li>
              <li><a href="#preuves">Preuves</a></li>
              <li><a href="#signaler">Signaler</a></li>
              <li><a href="#se-proteger">Se protéger</a></li>
            </ul>
          </div>

          <div className="footer__links">
            <h4>Ressources officielles</h4>
            <ul>
              <li><a href="https://signal.conso.gouv.fr" target="_blank" rel="noopener noreferrer">SignalConso (DGCCRF)</a></li>
              <li><a href="https://www.internet-signalement.gouv.fr" target="_blank" rel="noopener noreferrer">Pharos (Signalement internet)</a></li>
              <li><a href="https://www.cybermalveillance.gouv.fr" target="_blank" rel="noopener noreferrer">Cybermalveillance.gouv.fr</a></li>
              <li><a href="https://www.service-public.fr/particuliers/vosdroits/F1537" target="_blank" rel="noopener noreferrer">Dépôt de plainte en ligne</a></li>
            </ul>
          </div>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <div className="footer__legal">
            <p>
              Ce site est un site d'information citoyenne à but non lucratif. Les témoignages publiés sont fournis
              volontairement par les victimes. Les faits rapportés sont présentés à titre informatif.
              Ce site n'est pas un service juridique.
            </p>
          </div>
          <div className="footer__copyright">
            © {new Date().getFullYear()} JumpVendor Alert — Tous droits réservés
          </div>
        </div>
      </div>
    </footer>
  );
}
